module.exports = __webpack_public_path__ + "img/course-empty.c14b8aa7.png";